import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const VisaByType  = () => {
    const { slug } = useParams();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaByTypes,setVisaByTypes] = useState([]);
    useEffect(() => {
        console.log("useEffect:", slug);
        if (!slug) return;
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}/${slug}`)
            .then(response => setVisaByTypes(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, [slug]);

    return (
        <main className="main">
            <div className="site-breadcrumb"  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">{visaByTypes?.visa_type_name}</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link className="nav-link" to={'/'}>হোম</Link></li>
                        <li className="active">{visaByTypes?.visa_type_name}</li>
                    </ul>
                </div>
            </div>

            <div className="visa-area py-100">
                <div className="container">
                    <div className="visa-wrap wow fadeInUp" data-wow-delay=".25s">
                        <div className="row g-4">
                            {visaByTypes?.visas?.length > 0 ? (
                                visaByTypes.visas.map((visaByType, index) => (
                                    <div className="col-md-6 col-lg-3" key={index}>
                                        <Link to={`/visa/details/${visaByType.slug}`} className="text-decoration-none">
                                            <div className="card feature-item">
                                                <div className="card-header d-grid justify-content-center">
                                                    <div>
                                                        <img src={`${backendBaseUrl}${visaByType?.image}`} alt="" />
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="feature-content">
                                                        <h6 className="text-center fw-bold">{visaByType?.name}</h6>
                                                        <p align="justify">
                                                            <small>{visaByType?.short_description}</small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center">
                                    <p>No data found</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </main>
    );
};

export default VisaByType;